// extracted by mini-css-extract-plugin
module.exports = {"alert":"NotificationBox_alert__1QSSQ","success":"NotificationBox_success__26veO","btn":"NotificationBox_btn__HLShK","wrap":"NotificationBox_wrap__35AiL"};